import { render, staticRenderFns } from "./AGCCheckbox.vue?vue&type=template&id=5ad09d0e&scoped=true&"
import script from "./AGCCheckbox.vue?vue&type=script&lang=js&"
export * from "./AGCCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AGCCheckbox.vue?vue&type=style&index=0&id=5ad09d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad09d0e",
  null
  
)

export default component.exports